import { Box, Text, HStack, Image } from "@chakra-ui/react";
import ToastSuccessIcon from "@/assets/images/toast/success.svg";
import ToastErrorIcon from "@/assets/images/toast/error.svg";
import ToastWarningIcon from "@/assets/images/toast/warning.svg";
import {
  ToastComponentProps
} from "@/types";

export const ToastComponent = (props: ToastComponentProps) => {
  const { title, status, description } = props;

  return (
    <Box 
      bg='white' 
      p={1}
      pr="10"
      boxShadow="0px 2px 20px 2px rgba(0,0,0,0.1)"
      borderRadius="60px"
      w="570px"
    >
      <HStack gap="3">
        <Box>
          {status === "success" && <Image w="55px" src={ToastSuccessIcon} />}
          {status === "error" && <Image w="55px" src={ToastErrorIcon} />}
          {status === "warning" && <Image w="55px" src={ToastWarningIcon} />}
        </Box>
        <Box>
          {title && (
            <Text mb="0" lineHeight="1.2" fontSize="md" fontWeight="500">
              {title}
            </Text>
          )}
          {description && (
            <Text mt="1" color="brand.grey.500" fontWeight="400">
              {description}
            </Text>
          )}
        </Box>
      </HStack>
    </Box>
  );
};
